//获取url的参数
export const getQueryString = (name) => {
  const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]); return null;
}
export function getUrlParams(url) {
  // 检查是否传入了 URL，否则使用当前页面的 URL
  if (!url) {
    url = window.location.href;
  }

  // 获取 '#' 后的部分
  const hash = url.split('#')[1] || '';
  
  // 检查 '?' 后面的查询参数部分
  const queryString = hash.split('?')[1] || '';

  // 使用 URLSearchParams 解析查询参数
  const params = new URLSearchParams(queryString);

  // 将参数转为对象
  const result = {};
  for (const [key, value] of params.entries()) {
    result[key] = value;
  }

  return result;
}

export function debounce(fn, wait) {
  let timeout = null;
  return function() {
      let context = this;
      let args = arguments;
      if (timeout) clearTimeout(timeout);
      let callNow = !timeout;
      timeout = setTimeout(() => {
          timeout = null;
      }, wait);
      if (callNow) fn.apply(context, args);
  };
}

export function throttle(fn, wait) {
  let previous = 0;
  return function() {
      let context = this;
      let args = arguments;
      let now = new Date();
      if (now - previous > wait) {
          fn.apply(context, args);
          previous = now;
      }
  };
}

export function getPlatform() {
  const ua = window.navigator.userAgent.toLowerCase();
  if (ua.indexOf('alipayclient') > - 1) {
    return 'Alipay'
  } else if (ua.indexOf('micromessenger') > - 1) {
    return 'Wechat'
  } else {
    return 'Other'
  }
}